module.exports = __webpack_public_path__ + "static/media/matilde-special-adventour-tired.2064f15a.png";